<script setup>
import moment  from "moment";
import Comment from "@/components/common/Comment.vue";
import Alert from "@/components/common/Alert.vue";
import BlockEdit from "@/components/confirm/BlockEdit.vue";
import { parse } from 'js-html-parser';
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-card
  flat
  min-width="375px"
  max-width="900px"
>
<v-card
    flat
>
<v-card-title>
    下記のリリース原稿を確認してください。原稿にコメントしたい場合はコメントしたい箇所をクリック、またはタップするとコメント入力欄が表示されます。
</v-card-title>

<v-card
    flat
    outlined
    v-if="user_kind=='会員'"
>
<v-card-text class="pb-1 pt-5">
<h2 class="editor_h2">
招待URL
</h2>
</v-card-text>
<v-card-text class="py-1">
以下の招待URLを設定したパスワードを添えて確認者の方に共有してください。<v-icon small>mdi-refresh</v-icon>を押下するとURLを再発行できます。
</v-card-text>
<v-card-text class="py-1 pb-10">
    <v-row class="my-0">
        <v-col>
            <v-text-field
              v-model="confirm_url"
              hide-details="auto"
              dense
              disabled
            ></v-text-field>
        </v-col>
        <v-col cols="2">
            <v-btn
                @click="copy"
				color="#E13532"
				dark
            >
                コピー
            </v-btn>
        </v-col>
    </v-row>
    <v-row>
        <v-col class="py-0" cols="4">
            <v-switch
              v-model="shared"
              label="共有する"
              color="red darken-3"
              :value="shared"
              hide-details
              class="my-0"
            ></v-switch>
        </v-col>
        <v-col class="py-0">
            <v-form ref="test_form">
            <v-row>
            <v-col class="py-0 px-0">
            <v-text-field
                v-model="password"
                dense
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="form.rules"
                :type="show1 ? 'text' : 'password'"
                :counter="!noValidation"
                :hint="form.hint"
                :placeholder="form.placeholder"
                :hide-details="noValidation"
                @click:append="show1 = !show1"
            ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="5">
                <v-btn
                    :disabled="check_flg"
                    @click="pass()"
					dark
					color="primary"
                >
                    <v-icon>
                        mdi-lock
                    </v-icon>
                    パスワード再設定
                </v-btn>
            </v-col>
            </v-row>
            </v-form>

</v-col>
    </v-row>
</v-card-text>
</v-card>
<v-card-text class="px-1">
<v-card
    class="mt-2 ql-editor"
    min-height = "650px"
    max-width="750px"
    style="max-height:inherit;margin:0 auto;"
    outlined
    flat
>
    <v-card-text>
        <p class="confarea">{{ dsp_direction }}</p>
    </v-card-text>
    <v-card-title class="pt-0">
        <h1 class="preview_title" v-html="dsp_title">
        </h1>
    </v-card-title>
    <v-card-subtitle class="preview_title preview_subtitle pt-2" v-html="dsp_subtitle">
    </v-card-subtitle>
    <v-card-text
        style="text-align:right"
    >
        <p class="confarea">
        {{ release_date }}<br >
        <span v-html="dsp_signature"></span>
        </p>
    </v-card-text>
    <v-card-text>
        <div v-html="dsp_summary" class="preview_doc preview_summary"></div>
    </v-card-text>
    <v-card-text class="px-3">
    <v-expansion-panels flat id="click_case" popout v-model="panel">
      <v-expansion-panel
        v-for="(doc,i) in doc_element"
        :key="i"
      >
        <v-expansion-panel-header hide-actions class="py-0 px-0" @click="openpanel(doc.id)">
              <v-badge
                :content="comment_badge(doc.id)"
                :value="comment_badge(doc.id)"
                color="error"
                overlap
               >
                <p :id="doc.id"  v-html="doc.innerHTML" v-if="comment_select(doc.id).length != 0" style="background-color:pink" />
                <p :id="doc.id"  v-html="doc.innerHTML" v-else />
            </v-badge>
        </v-expansion-panel-header>
        <v-expansion-panel-content
            class="py-0 px-0"
            :id="'block-'+doc.id"
        >
            <v-card
                flat
            >
                <v-card-text class="px-0 py-2">
                    <v-card
                        flat
                    >
                    <v-toolbar
                        flat
						v-if="user_kind=='会員'"
                    >
                        <v-btn @click="openBlockEdit()" color="#E13532" dark><v-icon>mdi-tooltip-edit</v-icon>段落を編集</v-btn>
                    </v-toolbar>
                    <v-card-text class="py-0">
                    <v-list
                        style="max-height: 300px"
                        class="overflow-y-auto"
                        :id="'comment-'+doc.id"
                        v-if="comment_select(doc.id).length>0"
                    >
                        <v-list-item v-for="comment,index in comment_select(doc.id)" :key="index" class="mb-2 px-0">
                            <Comment :sendcomment="comment" />
                        </v-list-item>
                    </v-list>
                     <Alert messagetitle="コメントはありません" message="下記のフォームで先方とメッセージを交換できます" messagetype="0" blockheight="120px" v-else />
                    </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-text class="px-0">
                    <v-row class="mx-0">
                        <v-col
                            class="py-2 pl-0 pr-2"
                            height="25px"
                        >
                            <v-text-field
                              v-model="comment"
                              hide-details="auto"
                              dense
                              outlined
                              id="comment-field"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1" class="px-0">
                            <div class="send">
                            <v-icon
                                color="#E13532"
                                :disabled="sendable"
                                @click="commentsend(doc.id)"
                            >
                                mdi-send-circle
                            </v-icon>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    </v-card-text>
</v-card>
</v-card-text>
<v-card-text class="px-0">
<v-card flat outlined>
    <v-card-title>
        <h2 class="editor_h2">総評コメント</h2>
    </v-card-title>
        <v-card-text class="px-0 py-2">
            <v-list>
                <v-list-item v-for="comment,index in comment_select('')" :key="index" class="mb-2 px-1">
                    <Comment :sendcomment="comment" />
                </v-list-item>
            </v-list>
        </v-card-text>
    <v-card-text class="pb-0">
    <v-textarea
           clearable
           clear-icon="mdi-close-circle"
           label="全体コメント"
           auto-grow
           v-model="doc_comment"
           outlined
        id="comment-field"
    ></v-textarea>
    </v-card-text>
    <v-card-actions>
        <v-spacer />
        <v-btn
            :disabled="doc_sendable"
            color="#E13532"
            dark
            @click="commentsend('')"
        >
            <v-icon
            >
                mdi-send-circle
            </v-icon>
            送信
        </v-btn>
    </v-card-actions>
</v-card>
</v-card-text>
</v-card>
<BlockEdit ref="bedit" :blockcomment="blockcomment" />
</v-card>
</template>
<script>
export default  {
    props: {
        noValidation: {
          type: Boolean,
          default: false
        }
    },
    computed : {
        form () {
            const min = '8文字';
            const msg = `${min}。半角英数字_-が使えます`;
            const required = v => !!v || ''
            const format = v => /^[\w-]{8,8}$/.test(v) || msg;
            const rules = this.noValidation ? [required] : [format];
            const hint = this.noValidation ? undefined : msg;
            const placeholder = this.noValidation ? undefined : min;
            return { rules, hint, placeholder };
        },
        uuid : function(){
            return this.$store.getters['doc_info/get_uuid'];
        },
        title : function() {
            return this.$store.getters['doc_info/get_title'];
        },
        doc_id : function() {
            return this.$store.getters['doc_info/get_doc_id'];
        },
        sub_title : function() {
            return this.$store.getters['doc_info/get_subtitle'];
        },
        summary : function() {
            return this.$store.getters['doc_info/get_summary'];
        },
        release_date : function() {
            let reldate = "○○○○年○○月○○日"
            if(this.$store.getters['doc_info/get_release_date'] != "" && this.$store.getters['doc_info/get_release_date'] != null)
                reldate = moment(this.$store.getters['doc_info/get_release_date']).format('YYYY年MM月DD日');
            return reldate;
        },
        e_doc : function() {
            return this.$store.getters['doc_info/get_doc'];
        },
        direction : function() {
            return this.$store.getters['doc_info/get_direction'];
        },
        signature : function() {
            return this.$store.getters['doc_info/get_signature'];
        },
        selected_word : function() {
            return this.$store.getters['preview/get_word'];
        },
        user_kind : function(){
            return this.$store.getters['member_info/get_user_kind'];
        },
		blockcomment : function(){
			return this.comment_select(this.selected_id);
		},
		share_flg : function(){
            return this.$store.getters['doc_info/get_share_flg'];
		},
    },
    watch : {
		shared   : function(){
			this.share_flg_set();
		},
        password : function(){
            if (this.$refs.test_form.validate()) {
                this.check_flg = false;
            }
            else
            {
                this.check_flg = true;
            }
        },
        comment : function(){
            if(this.comment != "")
            {
                this.sendable = false;
            }
            else
            {
                this.sendable = true;
            }
        },
        doc_comment : function(){
            if(this.doc_comment != "")
            {
                this.doc_sendable = false;
            }
            else
            {
                this.doc_sendable = true;
            }
        },
        title: function(){
            this.init();
        },
        sub_title: function(){
            this.init();
        },
        summary: function(){
            this.init();
        },
        e_doc : function(){
            this.init();
        },
        selected_word: function(){
            if(this.selected_word == "")
            {
                this.init();
                return
            }
            this.dsp_title = this.highlight(this.title,this.selected_word);
            this.dsp_subtitle = this.highlight(this.sub_title,this.selected_word);
            this.dsp_summary = this.highlight(this.summary,this.selected_word);
            this.dsp_doc = this.highlight(this.e_doc,this.selected_word);
        },
        direction : function(){
            this.init();
        },
        signature : function(){
            this.init();
        },
    },
    data () {
      return {
        mo          : null,
        panel       : [],
        selected_id : "",
        password    : "",
        check_flg   : true,
        show1: false,
        shared       : false,
        confirm_url  : "",
        comment_list : [],
        comment_area : false,
        comment      : "",
		beforeHeight : 0,
        doc_comment  : "",
        timeout      : null,
        sendable     : true,
        doc_sendable     : true,
        comment_tag  : null,
        dsp_direction : "宛名(例：報道関係者各位)",
        dsp_signature : "署名(例：〇〇株式会社)",
        dsp_title : "プレスリリースタイトル",
        dsp_subtitle : "プレスリリースサブタイトル",
        dsp_summary : "概要説明",
        dsp_doc : "",
        doc_elem : [],
      }
    },
    methods : {
		selected_id_update : function(id){
			this.selected_id = id;
			this.getcomment();
		},
        openBlockEdit : function(){
            this.$refs.bedit.open(this.selected_id);
        },
        openpanel   : function(blockid){
            if(this.selected_id != blockid)
                this.selected_id = blockid;
            else
                this.selected_id = "";
        },
        copy        : function(){
            navigator.clipboard.writeText(this.confirm_url);
        },
        share_flg_set : async function(){
            var params = new URLSearchParams();
            params.append("doc_id",this.doc_id);
            params.append("share_flg",this.shared);    
            await axios.post("/api/release/set_shareflg",params)
            .then(() => {
            })
            .catch((error) => {
                console.error('失敗です', error);
            });
         
        },

        commentsend : async function(blockid){
            this.sendable = true;
            var params = new URLSearchParams();
            params.append("block_id",blockid);
            if(blockid=='')
                params.append("comment",this.doc_comment);
            else
                params.append("comment",this.comment);
            params.append("doc_id",this.doc_id);
            await axios.post("/doc/set_comment",params)
            .then(response => {
				this.comment_scrol = true;
                this.comment_list = response.data;
                this.comment = "";
                this.doc_comment="";
                this.selected_id = blockid;
            })
            .catch((error) => {
                console.error('失敗です', error);
            });
        },
        pass           : async function(){
            var params = new URLSearchParams();
            params.append("doc_id",this.doc_id);
            params.append("password",this.password);    
            await axios.post("/api/release/set_password",params)
            .then(() => {
            })
            .catch((error) => {
                console.error('失敗です', error);
            });
         
        },
        getcomment     : async function(){
            if(this.doc_id == "")return;
            var params = new URLSearchParams();
            params.append("doc_id",this.doc_id);
            await axios.post("/doc/get_comment",params)
            .then(response => {
                this.comment_list = response.data;
                this.comment = "";
            })
            .catch((error) => {
                console.error('失敗です', error);
            });
    
        },
		comment_badge : function(block_id){
			let badge_cnt = 0;
            for(let cnt = 0 ; cnt < this.comment_list.length ; cnt++)
            {
                if(this.comment_list[cnt].block_id == block_id
				&& this.comment_list[cnt].self == 'f'
				&& this.comment_list[cnt].checkflg=='f')
                {
					badge_cnt++;
                }
            }
            return badge_cnt;
		},
        comment_select : function(block_id){
            let return_list = [];
            for(let cnt = 0 ; cnt < this.comment_list.length ; cnt++)
            {
                if(this.comment_list[cnt].block_id == block_id)
                {
                    return_list.push(this.comment_list[cnt]);
                }
            }
			console.log(return_list);
            return return_list;
        },
        highlight : function(str, word ){
            var SearchString = '('+word+')';
            var RegularExp= new RegExp( SearchString, "g" );
            var ReplaceString = '<span style="background-color: yellow;">$1</span>';
            var ResString = str.replace( RegularExp , ReplaceString );
            return ResString;
        },
        init : function(){
            if(this.title != "" && this.title != null)
                this.dsp_title = this.title;
            else
                this.dsp_title = "プレスリリースタイトル"
            if(this.sub_title != "" && this.sub_title != null)
                this.dsp_subtitle = this.sub_title;
            else
                this.dsp_subtitle = "プレスリリースサブタイトル";

            if(this.summary != "" && this.summary != null)
                this.dsp_summary = this.summary.replaceAll("\n","<br />");
            else
                  this.dsp_summary = "概要説明";

            if(this.e_doc != "" && this.e_doc != null && this.e_doc!='<p>\n</p>')
            {
                this.dsp_doc = this.e_doc.replaceAll("<p>\n</p>","<br>");
            }
            else
            {
                this.dsp_doc = "リリース本文(最大8000文字)";
            }

            if(this.direction!="" && this.direction!=null)
            {
                this.dsp_direction = this.direction;
            }
            else
            {
                this.dsp_direction = "宛名(例：報道関係者各位)";
            }
            if(this.signature!="" && this.signature != null)
            {
                this.dsp_signature = this.signature.replaceAll("\n","<br />");
            }
            else
            {
                this.dsp_signature="署名(例：〇〇株式会社)";
            }
			if(this.share_flg=='t')
			{
				this.shared = true;
			}
            this.doclist();
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.getcomment();
            }, 100);

        },
        clickelement : function(e){
            var elem = e.target;
            if(elem.tagName != 'P')
            {
                for(let cnt = 0 ; cnt < 5; cnt++)
                {
                    elem = elem.parentElement;
                    if(elem.tagName == 'P')
                        break;
                }
            }
            this.comment_tag = elem.innerHTML;
            this.comment_area = true;
            
        },
        doclist : function(){
            let element=parse(this.dsp_doc);
            this.doc_element=[];
            for(let cnt = 0 ; cnt < element.childNodes.length ; cnt++)
            {
                if(element.childNodes[cnt].nodeType!=3)
                {
                    this.doc_element.push(element.childNodes[cnt]);
                }
            }
        },
        servdom : function(){
            if(this.selected_id == "")
                return;

            let elem = document.getElementById('comment-'+this.selected_id);
            if(elem != null)
            {
                if(elem.scrollHeight != this.beforeHeight)
				{
                    elem.scrollTop=elem.scrollHeight;
					this.beforeHeight = elem.scrollHeight;
				}
            }
			else
			{
				this.beforeHeight = 0;
			}
        },
    },
    created : function(){
        this.init();    
    },
    mounted : function(){
        this.confirm_url = "https://qlipper.jp/doc/?uid="+this.uuid;
        var element = document.getElementById('click_case');
        this.mo = new MutationObserver(this.servdom);
        var config = {
          childList: true,
          attributes: true,
          characterData: false,
          subtree: true,
        };

        //監視の開始
        this.mo.observe(element, config);
    },
    beforeDestroy : function(){
        this.mo.disconnect();
    },
  }
</script>
